import { AutocompleteInput } from 'ra-ui-materialui'
import React from 'react'
import { APIEntity } from 'services/api/entities'
import { useKGetList } from 'services/hooks/useKGetList'
import { ChoiceInputProps } from 'types/common'

type Props = ChoiceInputProps & {
  entity: APIEntity
}

const CustomAutocompleteInput: React.FC<Props> = ({
  entity,
  optionText = 'name',
  ...props
}) => {
  const choices = useKGetList(entity)

  return (
    <AutocompleteInput
      choices={choices}
      optionText={optionText}
      {...props}
      style={{ width: '256px' }}
    />
  )
}

export default CustomAutocompleteInput
